import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { InitiativesSettings, InitiativesSettingsService } from 'src/app/core/services/initiatives-settings.service';

@Component({
  selector: 'app-progressive-initiatives',
  templateUrl: './progressive-initiatives.component.html',
  styleUrls: ['./progressive-initiatives.component.scss']
})
export class ProgressiveInitiativesComponent implements OnInit {
  /* --------------------------------- Fields --------------------------------- */
  sections = [
    {
      id: "various_development_works_status",
      title: "Various Development Works Status"
    },
     {
      id: "cooperative_societies",
      title: "Cooperative societies"
    },
    {
      id: "sports_development",
      title: "Sports development"
    },
    {
      id: "youth_empowerment",
      title: "Youth empowerment"
    },
    {
      id: "support_for_farming_sector",
      title: "Support for farming sector"
    }
  ];
  initiativesSettings!:InitiativesSettings;

  public initiativesConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 4,
    speed: 2000,
    spaceBetween: 15,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    keyboard: true,
    loop: false,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    // autoplay: true,
    slidesOffsetAfter: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.initiatives-button-next',
      prevEl: '.initiatives-button-prev',
    },
    breakpoints: {
      240: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  };
  lang = "en";
/* --------------------------------- Fields --------------------------------- */

  constructor(private initiativesSettingsService: InitiativesSettingsService,
    private route: ActivatedRoute) { }

/* ---------------------------- Life Cycle hooks ---------------------------- */

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(data=>{
      this.lang = data.get('lang') ?? 'en';
    })
    this.initiativesSettingsService.getInitiativesSettings().subscribe(data=>{
      console.log(data);
      this.initiativesSettings = data;
    })
  }

  public onIndexChange(index: number): void {
    console.log('Swiper index: ', index);
  }
}
